import styled, { css } from 'styled-components';
import { Icon } from 'src/components';

export const Card = styled.div(
  ({ theme }) => css`
    background-color: ${theme.co.primary98};
    border: ${theme.bo.mediumWidth} solid ${theme.co.primary20};
    border-radius: ${theme.bo.mediumLarge};
    padding: ${theme.sz.s6};
    position: relative;

    width: 100%;

    @media (max-width: ${theme.sz.maxMobileBreakpoint}) {
      padding: ${theme.sz.s4};
    }
  `,
);

export const Title = styled.div(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.xs};
  `,
);

export const Description = styled.div(
  ({ theme }) => css`
    ${theme.typography.paragraph.s};
  `,
);

export const Image = styled.img(
  ({ theme }) => css`
    width: ${theme.sz.s40};
  `,
);

export const BottomWrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
    margin-top: ${theme.sz.s4};
  `,
);

export const CloseButton = styled.button(
  ({ theme }) => css`
    background: none;
    border-radius: ${theme.bo.round};
    border: none;
    top: ${theme.sz.s2};
    right: ${theme.sz.s2};
    box-sizing: content-box;
    padding: ${theme.sz.s1};
    position: absolute;

    &:focus {
      box-shadow: 0 0 0 3px ${({ theme }) => theme.co.information50};
    }
  `,
);

export const CloseIcon = styled(Icon)(
  ({ theme }) => css`
    cursor: pointer;
    position: relative;
    font-size: ${theme.sz.s6};

    svg {
      filter: 'none';
    }
  `,
);
